import {
  arrayToRecordBy,
  cellNotFilter,
  emptyCellObject,
  EstadoCuadreENUM, EstadoGestionInventarioENUM, formatDateWithTime,
  handleErrorForm,
  OPCIONES_ESTADO_GESTION_INVENTARIO,
  ROUTER_PATHS, sanitizeTodos,
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering
} from "@/shared";
import { useFetchUbicacionProductoSimple } from "@/shared/actions/erp";
import { ICuadreInventario, ICuadreInventarioForm } from "@/shared/interfaces/erp/inventario/cuadre-inventario.interface";
import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { newCuadreSchema } from "../utils/cuadre-validation.schema";
import CustomCantidadInput from "@/shared/components/ui/CustomCantidadInput";
import { IUbicacionProducto, IUbicacionProductoParams, UbicacionesParams } from "@/shared/interfaces/erp/inventario";
import {
  Checkbox,
  Box, IconButton,
  Chip, TextField,
  Tooltip, Select, MenuItem,
  type SelectChangeEvent
} from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { useFetchPostCuadreInventario, useFetchPutCuadreInventario } from "@/shared/actions/erp/inventario/cuadre.actions";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useDetalleStore } from "./useDetalleStore.store";
import { IDataProducto } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";

const defaultArrayCategoria = [
  'EQUIPOS',
  'MATERIALES',
  'CONSUMIBLE',
  //'EQUIPOS DE PROTECCIÓN PERSONAL',
  'HERRAMIENTAS',
  'MATERIAL ELECTRICO',
  'MATERIALES DE FIBRA OPTICA',
  'PUBLICIDAD Y MARKETING',
  'PUNTOS DE RED',
  'SUJECION',
  'SUMINISTRO DE OFICINA',
  'SUMINISTROS DE LIMPIEZA',
  //'UNIFORMES',
  'VEHICULOS',
  'DIGITAL',
]

export type ISerieCuadre = {
  //id: string;
  serie: string;
  observacion: string;
  //id_ubicacion_producto: string
  check: boolean;

  cantidad_gestion?: number
  tipo_gestion?: EstadoGestionInventarioENUM
  id_serie?: string
};

export interface IDataCuadre {
  codigo: string
  id_ubicacion_producto: string
  id?: string
  producto: string
  cantidad: number
  check: boolean
  diferencia: number
  observacion: string
  ubicacion: string
  bodega: string
  series: ISerieCuadre[]
  //pre_selected_serie_cuadre: ISerieCuadre[] // Guarda todas las series
  //selected_serie_cuadre: ISerieCuadre[] // Guarda las series con las que interactua
  bodega_data?: any
  producto_data?: any
  ubicacion_data?: any

  cantidad_gestion?: number
  tipo_gestion?: EstadoGestionInventarioENUM
}
export interface ICuadreMap {
  [key: string]: IDataCuadre
}

interface UseCuadreInventarioState {
  editCuadre?: ICuadreInventario
}

export default function useCuadreInventario({
  editCuadre
}: UseCuadreInventarioState) {

  const [openEmailModal, setOpenEmailModal] = useState<boolean>(false);
  const [enabled, setEnabled] = useState(false);
  const disableForm = useMemo(() => !!editCuadre, [editCuadre?.id_cuadre]);

  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);

  const upsertInteraction = useDetalleStore((s) => s.upsertInteraction);
  const openSeriesModal = useDetalleStore((s) => s.openSeriesModal);
  const setDataProducto = useDetalleStore((s) => s.setDataProducto);
  const interactions = useDetalleStore((s) => s.interactions);
  const cleanCuadre = useDetalleStore((s) => s.cleanCuadre);
  const setInteractions = useDetalleStore((s) => s.setInteractions);

  const [defaultCategoria, setDefaultCategoria] = useState<string[]>(defaultArrayCategoria)

  const dateCuadre = dayjs().format('YYYY-MM-DD hh:mm');

  const defaultForm = {
    correos: [],
    fecha_creacion: dateCuadre,
    estado_cuadre: EstadoCuadreENUM.BORRADOR,
    con_stock: true
  };

  ///* form
  const form = useForm<ICuadreInventarioForm, any, ICuadreInventarioForm>({
    resolver: yupResolver(newCuadreSchema as any),
    defaultValues: defaultForm
  });

  const {
    control,
    reset,
    handleSubmit,
    formState: { isValid },
  } = form;

  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: 'correos',
  });

  ///* fetch
  const navigate = useNavigate();

  const {
    mutateAsync: mutateAsyncPostCuadre,
    isPending: isPendingPost
  } = useFetchPostCuadreInventario({
    navigate,
    returnUrl: ROUTER_PATHS.inventario.cuadreInventarioNav
  });

  const {
    mutateAsync: mutateAsyncPut,
    isPending: isPendingPut
  } = useFetchPutCuadreInventario({
    navigate,
    returnUrl: ROUTER_PATHS.inventario.cuadreInventarioNav
  })

  const [
    estado, bodega, ubicacion, producto, con_stock
  ] = form.watch([
    'estado', 'bodega', 'ubicacion', 'producto', "con_stock"
  ])

  const parametrosMateriales = useMemo(() => ({
    estado,
    bodega,
    ubicacion,
    producto,
    con_stock,
    categoria_producto_in: defaultCategoria.join(','),
  }), [estado, bodega, ubicacion, producto, defaultCategoria, con_stock]);

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    pageIndex,
    pageSize
  } = pagination;

  const {
    data: dataProductosEquipos,
    isLoading: isLoadingProductoEquipos,
    isRefetching: isRefetchingProdEquipos
  } = useFetchUbicacionProductoSimple({
    params: {
      ...parametrosMateriales,
      ...filterObject,
      page: pageIndex + 1,
      page_size: pageSize
    },
    enabled
  });


  ///* columns
  const handleStock = (data: IUbicacionProducto): {
    stock_unidad: string
    stock: number
  } => {

    const {
      producto_data: pd = {} as IUbicacionProducto["producto_data"],
      metros_actuales = 0,
      stock: stockRaw = 0,
    } = data;

    const usa_metros = Boolean(pd?.usa_metros);
    const stockNum = usa_metros ? metros_actuales : (stockRaw ?? 0);

    return {
      stock_unidad: usa_metros
        ? `${metros_actuales} (METROS)`
        : stockRaw.toString(),
      stock: +stockNum,
    }
  }

  const defaultValue = (data: IUbicacionProducto) => {
    const {
      id_ubicacion_producto,
      producto_data,
      producto
    } = data;

    const cuadre = interactions?.[id_ubicacion_producto]; // puede ser undefined

    return {
      codigo: producto,
      modelo_producto: producto_data?.modelo_producto,
      descripcion: producto_data?.descripcion,
      check: cuadre?.check ?? false,
      cantidad: cuadre?.cantidad ?? handleStock(data).stock,
      diferencia: cuadre?.diferencia ?? 0,
      observacion: cuadre?.observacion ?? "—",
      series: cuadre?.series ?? [],
      tipo_gestion: cuadre?.tipo_gestion ?? EstadoGestionInventarioENUM.NO_REQUIERE
    };
  };

  const columns = useMemo<MRT_ColumnDef<IUbicacionProducto>[]>(
    () => [
      {
        ...cellNotFilter,
        id: 'check',
        accessorKey: 'accion',
        header: 'Acción',
        size: 100,
        Cell: ({ row }) => {

          const base = row.original;

          return <Checkbox
            value={interactions[base.id_ubicacion_producto]?.check ?? false}
            inputProps={{ 'aria-label': 'controlled' }}
            checked={interactions[base.id_ubicacion_producto]?.check ?? false}
            onChange={e => {

              upsertInteraction(base.id_ubicacion_producto, {
                id_ubicacion_producto: base.id_ubicacion_producto,
                ...defaultValue(base),
                check: e.target.checked,
              } as any)

            }}
          />
        }
      },
      {
        accessorKey: 'series',
        header: 'Series',
        size: 130,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const base = row.original;

          if (row.original.series?.length == 0) {
            return "—"
          } else {
            return (
              <Box sx={{ display: 'flex', gap: '1rem' }
              }>
                <Tooltip title="Ver Series" >
                  <IconButton
                    onClick={() => {

                      /* handlePreSeries({
                        ...row.original as any,
                        ...defaultValue(row.original),
                      }); */
                      openSeriesModal(base.id_ubicacion_producto,
                        base.ubicacion!,
                        base.producto!)

                      setDataProducto(base.producto_data as IDataProducto)

                      upsertInteraction(base.id_ubicacion_producto, {
                        id_ubicacion_producto: base.id_ubicacion_producto,
                        ...defaultValue(base)
                      } as any)

                    }}
                  >
                    <QrCode2Icon color="primary" />
                  </IconButton>
                </Tooltip>
              </Box>
            );
          }
        }
      },
      {
        id: 'producto',
        accessorKey: 'producto',
        header: 'Cod Producto',
        Cell: ({ row }) => emptyCellObject(row.original.producto_data, 'codigo')
      },
      {
        id: 'descripcion_producto',
        accessorKey: 'descripcion_producto',
        header: 'Descripción',
        Cell: ({ row }) => emptyCellObject(row.original.producto_data, 'descripcion')
      },
      {
        id: 'categoria_producto',
        accessorKey: 'categoria_producto',
        header: 'Categoria',
        Cell: ({ row }) => emptyCellObject(row.original.producto_data, 'categoria_producto')

      },
      {
        ...cellNotFilter,
        id: 'stock_unidad',
        accessorKey: 'stock', ///* stock ubicacion
        header: 'Stock Sistema',
        Cell: ({ row }) => {
          return handleStock(row.original).stock_unidad
        }
      },
      {
        ...cellNotFilter,
        id: 'cantidad',
        accessorKey: 'cantidad',
        header: 'Stock fisico ubicación',
        Cell: ({ row }) => {
          const stockOperacion = handleStock(row.original);
          const base = row.original
          return <CustomCantidadInput<IUbicacionProducto>
            //value={row.original.cantidad ?? 0}
            value={interactions[base.id_ubicacion_producto]?.cantidad
              ?? stockOperacion.stock}
            handleValue={(value) => {

              const diferencia = +value - stockOperacion.stock

              upsertInteraction(base.id_ubicacion_producto, {
                ...defaultValue(base),
                id_ubicacion_producto: base.id_ubicacion_producto,
                cantidad: value,
                diferencia: diferencia,
                cantidad_gestion: Math.abs(diferencia),
              } as any)

            }}
            row={row} //* TODO: validar
          />
        },
      },

      {
        ...cellNotFilter,
        id: 'diferencia',
        accessorKey: 'diferencia',
        header: 'Diferencia',
        Cell: ({ row }) => {
          const formatSigned = (n: number) => (n > 0 ? `+${n}` : String(n));
          return <Chip
            label={formatSigned(interactions[row.original.id_ubicacion_producto]?.diferencia ?? 0)}
          />
        }
      },
      {
        id: 'bodega_nombre',
        accessorKey: 'bodega_nombre',
        header: 'Bodega',
        Cell: ({ row }) => emptyCellObject(row.original.bodega_data, 'nombre')
      },
      {
        id: 'ubicacion_nombre',
        accessorKey: 'ubicacion_nombre',
        header: 'Ubicacion',
        Cell: ({ row }) => emptyCellObject(row.original.ubicacion_data, 'nombre')
      },
      {
        ...cellNotFilter,
        id: 'observacion',
        accessorKey: 'observacion',
        header: 'Observación',

        Cell: ({ row }) => {
          const base = row.original;
          return (
            <TextField
              id={row.original.id_ubicacion_producto}
              variant="outlined"
              //value={row.original.observacion ?? '—'}
              value={interactions[base.id_ubicacion_producto]?.observacion ?? '—'}
              onChange={(value) => {

                upsertInteraction(base.id_ubicacion_producto, {
                  ...defaultValue(base),
                  id_ubicacion_producto: base.id_ubicacion_producto,
                  observacion: value.target.value
                } as any)

              }}
            />
          )
        },
      },

      {
        accessorKey: 'tipo_gestion',
        header: 'Tipo Gestión',
        size: 200,
        // Renderizamos el componente Select directamente en la celda
        Cell: ({ row }) => {
          const base = row.original;

          return (
            <Select
              disabled={row.original.series?.length != 0}
              value={interactions[base.id_ubicacion_producto]?.tipo_gestion
                ?? EstadoGestionInventarioENUM.NO_REQUIERE}
              size="small"
              fullWidth
              onChange={(e: SelectChangeEvent) => {

                upsertInteraction(base.id_ubicacion_producto, {
                  id_ubicacion_producto: base.id_ubicacion_producto,
                  ...defaultValue(base),
                  //unidad_medida: base.producto_data?.unidad_medida,
                  tipo_gestion: e.target.value,
                } as any)
              }

              }
            >
              {OPCIONES_ESTADO_GESTION_INVENTARIO.map((opcion) => (
                <MenuItem key={opcion} value={opcion}>
                  {opcion}
                </MenuItem>
              ))}
            </Select>
          );
        },
      },

      {
        ...cellNotFilter,
        id: 'cantidad_gestion',
        accessorKey: 'cantidad_gestion',
        header: 'Cantidad gestión',
        Cell: ({ row }) => {
          const base = row.original          
          return <CustomCantidadInput<any>
            //value={row.original.cantidad ?? 0}
            disabled={row.original.series?.length != 0}
            value={interactions[base.id_ubicacion_producto]?.cantidad_gestion
              ?? 0}
            handleValue={(value) => {

              if(+value > +base.stock ){
                toast.info('El valor no puede ser mayor a la cantidad en inventario')
                return
              }
              upsertInteraction(base.id_ubicacion_producto, {
                ...defaultValue(base),
                id_ubicacion_producto: base.id_ubicacion_producto,
                cantidad_gestion: value,
              } as any)

            }}
            row={row as any} //* TODO: validar
          />
        },
      },

    ],
    [interactions]
  );

  ///* handele
  async function onSubmit() {


    if (!isValid) {
      toast.error('Ingresar campos requeridos.')
      return;
    }

    if (!interactions) {
      return toast.info('No existe datos.')
    }

    const arrWithKey = Object.entries(interactions).map(([key, value]) => ({
      key,
      ...value
    }));

    const send = {
      ...form.getValues(),
      equipos_utilizados: arrWithKey,
      correos: form.getValues().correos?.flatMap(e => e.correo).filter(e => e),
    }

    if (disableForm) {
      await mutateAsyncPut({
        id: editCuadre?.id_cuadre!,
        data: send as any
      })
      return;
    }

    await mutateAsyncPostCuadre(send as any)

  }


  ///* Iniciar cuadre: pide confirmación la primera vez y registra fecha_hora_inicio
  function onCargarProductosFiltrados() {
    // Si el cuadre ya fue iniciado, solo recarga los productos con los filtros actuales
    if (form.getValues('fecha_hora_inicio')) {
      setEnabled(true);
      return;
    }

    setConfirmDialogIsOpen(true);
    setConfirmDialog({
      isOpen: true,
      title: 'Iniciar cuadre',
      subtitle: '¿Desea iniciar el cuadre? Se registrará la fecha y hora de inicio.',
      btnTitle: 'Sí',
      onConfirm: () => {
        form.setValue('fecha_hora_inicio', new Date().toISOString());
        setEnabled(true);
        setConfirmDialogIsOpen(false);
      },
      onClose: () => {
        setConfirmDialogIsOpen(false);
      },
    });
  }

  const onSubmitHandler = useCallback(
    (e?: React.BaseSyntheticEvent) => {
      e?.preventDefault();
      handleSubmit(onSubmit, (error) => {
        console.log(error);
        return;
      })(e);
    },
    [handleSubmit, onSubmit]
  );

  ///* useMemo

  const paramsUbicaciones = useMemo<UbicacionesParams>(
    () => ({
      bodega: sanitizeTodos(bodega)
    }),
    [bodega]
  );

  const paramsProducto = useMemo<IUbicacionProductoParams>(
    () => ({
      bodega: sanitizeTodos(bodega),
      ubicacion: sanitizeTodos(ubicacion)
    }),
    [bodega, ubicacion]
  );

  ///* useEffect

  useEffect(() => {

    if (editCuadre?.id_cuadre) {

      reset({
        ...editCuadre as any,
        estado_cuadre: EstadoCuadreENUM.BORRADOR,
        fecha_creacion: formatDateWithTime(editCuadre.fecha_creacion)
      })

      const map = arrayToRecordBy(editCuadre.equipos_utilizados, (x) => x.id_ubicacion_producto);

      console.log(map);

      setInteractions(map)
      setEnabled(true)
    }



  }, [editCuadre?.id_cuadre])


  useEffect(() => {


    return () => {
      reset(defaultForm)
      cleanCuadre()
    }

  }, [])


  useLoaders(isPendingPut
    || isPendingPost)

  return {
    dataProductosEquipos,
    isLoadingProductoEquipos,
    isRefetchingProdEquipos,
    disableForm,
    columns,
    pagination,
    form,
    fields,
    openEmailModal,
    paramsUbicaciones,
    paramsProducto,
    enabled,
    columnFilters,
    setColumnFilters,
    setEnabled,
    onCargarProductosFiltrados,
    setPagination,
    append,
    remove,
    setOpenEmailModal,
    onSubmitHandler,
    defaultCategoria,
    setDefaultCategoria
  }

}